import PropTypes from 'prop-types'
import {
  Modal, Row, Col, Tabs, Tab
} from 'react-bootstrap'

import SignUpForm from '~/components/shared/AuthenticationModal/SignUpForm'
import LoginForm from '~/components/shared/AuthenticationModal/LoginForm'
import withLocale from '~/hocs/locale'

const AuthenticationModal = ({
  show, setShow, title, signupLabel, loginLabel
}) => {
  const handleClose = () => setShow(false)

  return (
    <Modal show={show} onHide={handleClose} backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title className="text-center">{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row className="my-3">
          <Col>
            <Tabs defaultActiveKey="signup" id="uncontrolled-tab-auth">
              <Tab eventKey="signup" title={signupLabel}>
                <div className="px-2 pt-4">
                  <SignUpForm onSubmit={handleClose} />
                </div>
              </Tab>
              <Tab eventKey="login" title={loginLabel}>
                <div className="px-2 pt-4">
                  <LoginForm onSubmit={handleClose} />
                </div>
              </Tab>
            </Tabs>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  )
}

AuthenticationModal.propTypes = {
  show: PropTypes.bool.isRequired,
  setShow: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  signupLabel: PropTypes.string.isRequired,
  loginLabel: PropTypes.string.isRequired,
}

export default withLocale('common', 'authModal')(AuthenticationModal)
